export default __webpack_public_path__ + "static/media/error.2421d6fc.png";